import React from 'react';
import { m } from 'framer-motion';
import { BookOpenIcon, LayersIcon, GraduationCapIcon, ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const steps = [{
  n: '1',
  title: 'Abre',
  icon: BookOpenIcon
}, {
  n: '2',
  title: 'Elige el bloque',
  icon: LayersIcon
}, {
  n: '3',
  title: 'Enseña',
  icon: GraduationCapIcon
}];
export function Solution() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-139" data-mp="97u14o4uhw5p">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-140" data-mp="96932ojbnv33">
        <SectionTag data-id="element-141" data-mp="487i1y2c5loz">La solución</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-142" data-mp="47el1ot6iak1">
          Matemáticas Listo es tu respuesta
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-143" data-mp="dzkbuv7p2lxn">
          Un sistema de 12 tomos listos para usar. Cada tomo cubre un curso completo. Cada clase tiene
          estructura clara. Cada día, menos estrés.
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-3xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-144" data-mp="1vuyl3m1zknn6">
        {steps.map((step, i) => <React.Fragment key={step.n} data-id="element-145" data-mp="1zwbrbx8zqsum" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-navy/10 bg-white p-6 text-center" data-id="element-146" data-mp="24vepcxqjzyt3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange/10" data-id="element-147" data-mp="2itcvjfuq0oxi">
                <step.icon size={22} className="text-orange-hover" data-id="element-148" data-mp="2nmego5litkpj" />
              </div>
              <p className="mt-3 font-heading text-base font-bold uppercase tracking-wide text-navy" data-id="element-149" data-mp="2sk7lovb388o8">
                {step.n}. {step.title}
              </p>
            </m.div>
            {i < steps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-orange/50 sm:block" aria-hidden="true" data-id="element-150" data-mp="32gsrhiuxlnt4" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-xl px-4 text-center text-sm font-semibold leading-relaxed text-navy sm:px-6 sm:text-base" data-id="element-151" data-mp="2mlmc90hnjmes">
        Abre un tomo. Elige el bloque. Enseña. Todo funciona.
      </p>
    </section>;
}